import { API_AUTH } from "./common";

export default {
  combo: () => API_AUTH.get("taikhoan/danh-sach-tai-khoan-combo", {}),
  combo2: () => API_AUTH.get("user/combo", {}),
  getCurrentUser: () =>
    API_AUTH.get("taikhoan/thong-tin-tai-khoan-hien-tai", {}),

  checkhansudung: (username) =>
    API_AUTH.get(`taikhoan/checkhansudung?username=${username}`, {}),

  checkRole: (roleName) =>
    API_AUTH.get(`taikhoan/kiem-tra-role?role=${roleName}`, {}),

  getLogoUrl: () => API_AUTH.get(`taikhoan/logo`, {}),

  getDanhSachRole: () => API_AUTH.get(`user/danhsachroles`, {}),
  getAllRole: () => API_AUTH.get(`menu/GetPhanQuyenByUser`, {}),
  getAllQuyen: () => API_AUTH.get(`phanquyen/GetAllQuyen`, {}),
  // getListCreateUser: () => API_AUTH.get("api/user/danhsachuser", {}),
  getAllUserName:() => API_AUTH.get("user/combo", {}),

  getAllUserInfor:()=>API_AUTH.get(`user/GetAllInfor`,{}),
  UpdateUserInfor:(data)=>API_AUTH.post(`user/UpdateUserInfor`,data),
  UserChangePass: (data)=>API_AUTH.post(`user/ChangePass`,data),
  getUserRoleDropdown: (params) => API_AUTH.get("get-user-dropdown-by-role", params),
  getMyRoles: () => API_AUTH.get("api/get-my-roles", {}),
  capNhatTrangThaiThoaThuan: (email) =>
    API_AUTH.post(`cap-nhat-trang-thai-thoa-thuan?email=${encodeURIComponent(email)}`),
};
